module.exports = __webpack_public_path__ + "img/hs-fatigue-cr2.3307e7c3.jpg";